import React from "react"
import Checkbox from "@mui/material/Checkbox"
import {Box} from "@mui/material"
import {styled} from "@mui/material/styles"

const checkboxBoxStyles = {
    width: 18,
    height: 18,
    border: "1px solid #F0F0F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
}

const uncheckedIcon = <Box sx={checkboxBoxStyles} />

const checkedIcon = (
    <Box
        sx={{
            ...checkboxBoxStyles,
            "&::after": {
                content: '""',
                width: 10,
                height: 6,
                borderLeft: "1px solid #FFB300",
                borderBottom: "1px solid #FFB300",
                transform: "rotate(-45deg)",
                display: "block",
                position: "relative",
                top: -2,
                left: 0,
            },
        }}
    />
)

const StyledCheckbox = styled(Checkbox)(() => ({
    padding: 12,
    color: "#F0F0F0",
    "&:hover": {
        backgroundColor: "transparent",
    },
}))

StyledCheckbox.defaultProps = {
    disableRipple: true,
    color: "default",
    icon: uncheckedIcon,
    checkedIcon: checkedIcon,
}

export default StyledCheckbox
